import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.PERMISSIONAMENTO.SET_ID_ORGAO_PERMISSIONAMENTO](state, idOrgao) {
		state.idOrgao = idOrgao
	},
	[mutationTypes.PERMISSIONAMENTO.SET_PERMISSOES_PERMISSIONAMENTO](state, permissoes) {
		state.permissoes = permissoes
	},
}
